import { createSimpleStore } from './factories/simpleStoreFactory';

type TimePickerShorthandState = {
  isShorthandEnabled: boolean;
};

type TimePickerShorthandActions = {
  setShorthandEnabled: (enabled: boolean) => void;
  toggleShorthand: () => void;
};

export type TimePickerShorthandStore = TimePickerShorthandState & TimePickerShorthandActions;

export const useTimePickerShorthandStore = createSimpleStore<TimePickerShorthandState, TimePickerShorthandActions>({
  name: 'TimePickerShorthandStore',
  initialState: {
    isShorthandEnabled: false
  },
  actions: (set) => ({
    setShorthandEnabled: (enabled: boolean) => set({ isShorthandEnabled: enabled }),
    toggleShorthand: () => set((state) => ({ isShorthandEnabled: !state.isShorthandEnabled }))
  })
});
